var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"toptitle"},[_vm._v("用工形式")]),_c('div',{staticClass:"topcont"},[_c('div',{ref:"bingtu",staticClass:"bingbox"}),_c('div',{ref:"bartu",staticClass:"barbox"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }